import React, { Component } from 'react';
import { get_texts, update_texts } from '../services/api';

class GroupEditor extends Component {
  constructor (props) {
    super(props);
    this.state = {
      collapsed: true
    };
  }

  countSentences = () => this.props.sentences.length

  countWords = () => this.props.sentences.reduce((words, sentence) => words + sentence.split(/\s+/).length, 0)

  handleTitleChange = (e) => this.props.onTitleChange(e.target.value);

  handleSentenceChange = (e) => {
    this.props.onSentenceChange(e.target.value.split(/\n+/))
  };

  remove = (e) => {
    if (window.confirm("Are you sure?")) {
      this.props.onRemove();
    }
  }

  toggle = (e) => this.setState({ collapsed: !this.state.collapsed });

  clean = () => {
    this.props.onSentenceChange(this.props.sentences.map((sentence) => 
      sentence.replace(/\[\d+\]?/g, '')))
  }

  render = () =>
    <section className="Group" data-collapsed={this.state.collapsed}>
      <section className="controls">
        <section className="control small-control"><button onClick={this.toggle} className="toggleButton"></button></section>      
        <section className="control"><label>Title: <input type="text" value={this.props.title} onChange={this.handleTitleChange} /></label></section>
        <section className="control">Sentences: {this.countSentences()}</section>
        <section className="control">Words: {this.countWords()}</section>
        <section className="control small-control"><button onClick={this.clean}>Clean (remove footnote references)</button></section> 
        <section className="control small-control"><button onClick={this.remove}>❌</button></section>
      </section>
      <section className="text">
        <textarea onChange={this.handleSentenceChange} value={ this.props.sentences.join('\n\n') }></textarea>
      </section>
    </section>
}

export default class TextsEditor extends Component {
  constructor (props) {
    super(props);
    this.state = {
      groups: [],
      loading: false,
      saving: false,
      hasChanges: false
    }
  }

  componentDidMount = () => {
    this.load();
  }

  load = () => {
    this.setState({ loading: true });
    get_texts()
      .then((groups) => {
        this.setState({ groups, loading: false, hasChanges: false })
      })
  }

  save = () => {
    update_texts(JSON.stringify(this.state.groups))
      .then(() => {
        this.setState({ saving: false, hasChanges: false });
      })
  }

  close = () => {
    if (this.state.hasChanges) {
      if (window.confirm("There are unsaved changes. Continue?")) {
        this.props.onClose();
      }
    } else {
      this.props.onClose();
    }
  }

  updateGroup = (g, processor, callback) => {
    const groups = this.state.groups;
    groups[g] = processor(groups[g]);
    this.setState({ groups, hasChanges: true }, callback);
  }

  handleGroupTitleChange = (g) => (title) => {
    this.updateGroup(g, (group) => {
      group.title = title;
      return group;
    });
  }

  handleGroupSentenceChange = (g) => (sentences) => {
    this.updateGroup(g, (group) => {
      group.sentences = sentences;
      return group;
    })
  }

  handleGroupRemove = (g) => () => {
    const groups = this.state.groups;
    groups.splice(g, 1);
    this.setState({ groups, hasChanges: true });
  }

  handleGroupAdd = () => {
    const groups = this.state.groups;
    groups.push({ title: '', sentences: [] });
    this.setState({ groups, hasChanges: true });
  }

  renderGroups = () =>
    <React.Fragment>
      <section className="controls main-controls">
        <section className="control"><button onClick={this.close}>Back</button></section>
        <section className="control"><button onClick={this.handleGroupAdd}>+</button></section>
        <section className="control"><button disabled={!this.state.hasChanges || this.state.saving} onClick={this.save}>{(this.state.saving) ? 'Saving...' : 'Save'}</button></section>
      </section>
      { this.state.groups.map((v, k) => 
          <GroupEditor
            key={k}
            title={v.title}
            sentences={v.sentences}
            onRemove={ this.handleGroupRemove(k) } 
            onTitleChange={ this.handleGroupTitleChange(k) }
            onSentenceChange={ this.handleGroupSentenceChange(k) } /> )}
    </React.Fragment>;

  renderLoading = () => {
    return 'Loading...';
  }

  render = () => {
    const view = (this.state.loading) ? this.renderLoading() : this.renderGroups();
    return <section>
      { view }
    </section>
  }
}


// WEBPACK FOOTER //
// ./src/components/TextsEditor.js